import { jsx as f } from "react/jsx-runtime";
import { useRef as i, useLayoutEffect as m } from "react";
import { Container as n } from "./styles.js";
import { ListItem as R } from "./styles.js";
import { useCarouselContext as u } from "../../context.js";
function x({ children: e, ...s }) {
  const o = i(null), { setListRef: r, updateNavigators: t } = u();
  return m(() => {
    r(o), t();
  }, [r, t]), /* @__PURE__ */ f(n, { ...s, ref: o, onScroll: t, children: e });
}
export {
  x as List,
  R as ListItem
};
